import { makeAPICall } from "../../utils/common";
import config from "../../utils/config";

export const GET_SCHEME_COUNT = "GET_SCHEME_COUNT";
export const GET_SCHEME_COUNT_SUCCESS = "GET_SCHEME_COUNT_SUCCESS";
export const GET_SCHEME_COUNT_FAILED = "GET_SCHEME_COUNT_FAILED";

export function getSchemeOverviewDetails(obj) {
  return (dispatch) => {
    const params = {
      url: `${config.apiBasePath.baseIp}schemeOverview`,
      dispatch,
      defaultAction: GET_SCHEME_COUNT,
      successAction: GET_SCHEME_COUNT_SUCCESS,
      failedAction: GET_SCHEME_COUNT_FAILED,
      type: "POST",
      headers: obj.headers,
      params: obj.params,
      // callback: callback,
    };
    makeAPICall(params);
  };
}
